import React from 'react';
import { FILTER_OPTIONS_IS_AND_IS_NOT } from './FilterUtils';

export const getPriceListFilterConfig = ({
	parts,
	fetchParts,
	fetchMultipleParts,
	vendors,
	fetchVendors,
	fetchMultipleVendors,
	targetCollectionName,
}) => {
	return [
		{
			label: 'Part',
			fieldName: 'partIds',
			mode: 'multiple',
			stateSlice: parts,
			targetCollectionName,
			fetch: fetchParts,
			fetchMultiple: fetchMultipleParts,
			renderItem: (part) => (
				<div className="flex flex-row items-center">
					<div>{part.name}</div>
					<div>
						{part.partNumber && (
							<span className="text-gray-400">&nbsp;{`- #${part.partNumber}`}</span>
						)}
					</div>
				</div>
			),
			filterOptions: FILTER_OPTIONS_IS_AND_IS_NOT,
		},
		{
			label: 'Vendor',
			fieldName: 'partEquipmentVendorIds',
			mode: 'multiple',
			stateSlice: vendors,
			targetCollectionName,
			fetch: fetchVendors,
			fetchMultiple: fetchMultipleVendors,
			filterOptions: FILTER_OPTIONS_IS_AND_IS_NOT,
		},
	];
};
